import styled from "@emotion/styled"
import { Colors, Intent } from "@blueprintjs/core"

export const Container = styled.div`
  margin: 10px 0;
  overflow-y: auto;
  max-height: 300px;
  position: relative;
`

export const TableWrapper = styled.div`
  .bp5-html-table {
    width: 100%;

    th {
      position: sticky;
      top: 0;
      background-color: ${Colors.DARK_GRAY5};
      z-index: 1;
    }

    td,
    th {
      text-align: left;
      padding: 8px;
    }

    tbody tr:nth-child(odd) {
      background-color: ${Colors.DARK_GRAY4};
    }
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 20px;
  color: ${Colors.GRAY3};
`

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`

// Map Intent to Colors
export const intentToColor = {
  [Intent.PRIMARY]: Colors.BLUE3,
  [Intent.SUCCESS]: Colors.GREEN3,
  [Intent.WARNING]: Colors.ORANGE3,
  [Intent.DANGER]: Colors.RED3,
  [Intent.NONE]: Colors.GRAY1,
}
